import { api_onlineOrder } from '@/utils/request'
/**
 * 概况
 */

 export const getHome = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/home',
    method: 'get',
    params
  })
};
/**
 * 入库管理
 */

// 生成入库单号
export const getWarehousingSn = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing/sn',
    method: 'post',
    data
  })
};
// 入库
export const addWarehousing = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing',
    method: 'post',
    data
  })
};
// 入库单列表
export const getWarehousing = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing',
    method: 'get',
    params
  })
};
// 单据-入库单
export const getDocumentWarehousing = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing/list',
    method: 'get',
    params
  })
};
// 单据-创建入库单
export const createDocumentWarehousing = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing/add',
    method: 'post',
    data
  })
};
// 入库单详情
export const getWarehousingMore = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing/'+id,
    method: 'get'
  })
};
// 入库单二维码明细
export const getWarehousingCode = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing/warehousingCode/'+params.id,
    method: 'get',
    params
  })
};
// 入库单二维码明细
export const getWarehousingCodeNum = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing/warehousingCodeNum/'+params.id,
    method: 'get',
    params
  })
};
// 入库单删除
export const delWarehousing = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing/'+id,
    method: 'DELETE',
  })
};
// 入库单码删除
export const delWarehousingCode = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing/warehousingCode/'+id,
    method: 'DELETE',
  })
};
// 入库单商品列表
export const getWarehousingGoods = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing/goodsList',
    method: 'get',
    params
  })
};
/**
 * 仓库出库
 */

// 仓库出库列表
export const getOutWarehousingList = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/warehousingList',
    method: 'get',
    params
  })
};
// 出库单关闭
export const outWarehousingClose = (sn,data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/close/'+sn,
    method: 'POST',
    data
  })
};

// 扫码
export const outScanCode = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing',
    method: 'PUT',
    data
  })
};
// 出库
export const setOutWarehousing = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/out/'+data.id,
    method: 'post',
    data
  })
};
// 取消出库
export const closeOutWarehousing = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/channel/'+id,
    method: 'post'
  })
};
// 出库二维码明细
export const getOutWarehousingCode = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/code/'+params.sn,
    method: 'get',
    params
  })
};
// 是否赠品设置
export const setOutWarehousingGift = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/gift/'+data.id,
    method: 'post',
    data
  })
};
// 快速出库
export const setOutWarehousingFast = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/fast',
    method: 'post',
    data
  })
};
//获取出库单
export const getOutWarehousingSn = ()=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/getOrderNo',
    method: 'get'
  })
};
/**
 * 仓库调仓
 */

// 调仓单列表
export const getTransferWarehousing = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing',
    method: 'get',
    params
  })
};
// 调仓单详情
export const getTransferWarehousingMore = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing/'+id,
    method: 'get'
  })
};
// 调仓单添加
export const addTransferWarehousing = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing',
    method: 'post',
    data
  })
};
// 调仓单关闭
export const closeTransferWarehousing = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing/close/'+id,
    method: 'post'
  })
};
// 调仓单二维码明细
export const getTransferWarehousingCode = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing/code/'+params.transfer_warehousing_sn,
    method: 'get',
    params
  })
};
// 调仓
export const setTransferWarehousing = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing/codeTransfer/'+data.id,
    method: 'post',
    data
  })
};
// 调仓扫码
export const setTransferWarehousingCode = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing/codeScans/'+data.id,
    method: 'post',
    data
  })
};
// 调仓单取消调仓
export const delTransferWarehousingCode = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing/code/'+id,
    method: 'DELETE',
  })
};
// 是否待完成的调仓单
export const transferWarehousingPending = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing/pending/'+id,
    method: 'get',
  })
};
/**
 * 退货管理
 */

// 获取退货订单号
export const getRefundOrderNo = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/refund/getOrderNo',
    method: 'get',
    params
  })
};
// 获取仓库位
export const getRefundWareHouse = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/refund/wareHouse',
    method: 'get',
    params
  })
};
// 获取退货单列表
export const getRefundOrder = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/refund',
    method: 'get',
    params
  })
};
// 获取渠道出库单列表
export const getOutWarehousingChannelList = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/channelList',
    method: 'get',
    params
  })
};
// 获取渠道退货单列表
export const getRefundOrderChannel = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/refund/channel',
    method: 'get',
    params
  })
};
// 退货详情
export const getRefundOrderMore = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/refund/'+id,
    method: 'get'
  })
};
// 创建退货单
export const addRefundOrder = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/refund',
    method: 'post',
    data
  })
};
// 退货单删除
export const delRefundOrder = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/refund/'+id,
    method: 'DELETE',
  })
};
// 退货单-添加商品
export const refundOrderScan = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/refund/scan',
    method: 'post',
    data
  })
};
// 关联二维码
export const getRefundOrderCode = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/refund/code/'+params.id,
    method: 'get',
    params
  })
};


/**
 * 单据管理
 */

// (出库单)出库单列表
export const getOutWarehousing = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing',
    method: 'get',
    params
  })
};
// (出库单)出库单详情
export const getOutWarehousingMore = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/'+id,
    method: 'get'
  })
};
// (出库单)出库单添加
export const addOutWarehousing = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing',
    method: 'post',
    data
  })
};
// (出库单)出库单关闭
export const closeRefundOrder = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/close/'+id,
    method: 'post'
  })
};


// (调拨单)调拨单列表
export const getAllocation = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/allocation',
    method: 'get',
    params
  })
};
// (调拨单)调拨单详情
export const getAllocationMore = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/allocation/'+id,
    method: 'get'
  })
};
// (调拨单)调拨协商记录
export const getAllocationLog = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/allocation/log/'+params.id,
    method: 'get',
    params
  })
};
// (调拨单)调拨单添加
export const addAllocation = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/allocation',
    method: 'post',
    data
  })
};
// (调拨单)出库单关闭
export const closeAllocation = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/allocation/'+id,
    method: 'post'
  })
};
// (调拨单)审核调拨单
export const handelAllocation = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/allocation/handel/'+data.sn,
    method: 'post',
    data
  })
};
// (调拨单)经销商商品
export const getAllocationDealerGoods = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/allocation/dealer/'+params.id,
    method: 'get',
    params
  })
};
// (调拨单)商品数量修改
export const editAllocation = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/allocation/'+data.sn,
    method: 'PUT',
    data
  })
};


/**
 * 码关系管理
 */

// 解除码列表
export const getDissolve = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/dissolve',
    method: 'get',
    params
  })
};
// 解除码关系 - 确认
export const dissolveConfirm = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/dissolve/confirm',
    method: 'post',
    data
  })
};
// 解除码关系操作提交
export const setDissolve = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/dissolve',
    method: 'post',
    data
  })
};
// 替换码列表
export const getReplace = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/replace',
    method: 'get',
    params
  })
};
// 替换码关系 - 确认
export const replaceConfirm = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/replace/confirm',
    method: 'post',
    data
  })
};
// 替换码关系操作提交
export const setReplace = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/replace',
    method: 'post',
    data
  })
};
/**
 * 市场稽查
 */

// 追踪查询
export const codeSearch = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/code/search',
    method: 'get',
    params
  })
};
//窜货经销商统计
export const fleeingWarningDealer = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/fleeingWarning/dealer',
    method: 'get',
    params
  })
};
//窜货商品统计
export const fleeingWarningProduct = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/fleeingWarning/product',
    method: 'get',
    params
  })
};
//窜货出库单统计
export const fleeingWarningOut = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/fleeingWarning/outWarehousing',
    method: 'get',
    params
  })
};
//窜货经销商详情记录
export const fleeingWarningDealerMore = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/fleeingWarning/dealerScans/'+params.id,
    method: 'get',
    params
  })
};
//窜货产品详情记录
export const fleeingWarningProductMore = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/fleeingWarning/productScans/'+params.id,
    method: 'get',
    params
  })
};
//窜货出库单详情记录
export const fleeingWarningOutMore = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/fleeingWarning/outWarehousingScans/'+params.id,
    method: 'get',
    params
  })
};
// 出库单窜货状态禁用恢复
export const setFleeingWarningStatus = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/fleeingWarning/'+id+'/status',
    method: 'post'
  })
};
// 区间二维码入库
export const createCodeRangeWarehousing = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehousing/createCodeRangeWarehousing',
    method: 'post',
    data
  })
};

/**
 * 库存报表
 */

// 获取总部库存
export const getStock = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/stock',
    method: 'get',
    params
  })
};
// 经销商库存
export const getStockDealer = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/stock/channelDealer',
    method: 'get',
    params
  })
};
// 门店库存
export const getStockStore = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/stock/channelStore',
    method: 'get',
    params
  })
};
// 库存详情
export const getStockMore = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/stock/'+params.id,
    method: 'get',
    params
  })
};
/**
 * 系统配置
 */

// 基础配置
export const getAdminSys = ()=>{
  return api_onlineOrder.request({
    url: 'fch/admin/sys',
    method: 'get'
  })
};
// 基础配置修改
export const setAdminSys = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/sys',
    method: 'post',
    data
  })
};
// 仓库/库位列表
export const getWarehouseList = ()=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehouse',
    method: 'get'
  })
};
// 编辑仓库/库位
export const editWarehouse = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehouse/'+data.wp_id,
    method: 'PUT',
    data
  })
};
// 添加仓库/库位
export const addWarehouse = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehouse',
    method: 'post',
    data
  })
};
// 删除产品批次
export const delWarehouse = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/warehouse/'+id,
    method: 'DELETE',
  })
};

// 收货人（门店/经销商）
export const getConsignee = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/consignee',
    method: 'get',
    params
  })
};

// 获取快速编辑
export const editFast = ()=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/fast/edit',
    method: 'get',
  })
};

// 导出
export const exportOrder = (params)=>{
  return api_onlineOrder.request({
    url: '/fch/admin/warehousing/export',
    method: 'get',
    params
  })
};


// 数据统计

// 窜货经销商分析
export const fleeingGoodsDealer = (params)=>{
  return api_onlineOrder.request({
    url: '/fch/admin/statistics/fleeingGoodsDealer',
    method: 'get',
    params
  })
};
// 窜货经销商商品分析
export const fleeingGoodsDealerGoods = (params)=>{
  return api_onlineOrder.request({
    url: '/fch/admin/statistics/fleeingGoodsDealerDetail',
    method: 'get',
    params
  })
};
// 窜货商品分析
export const fleeingGoods = (params)=>{
  return api_onlineOrder.request({
    url: '/fch/admin/statistics/fleeingGoods',
    method: 'get',
    params
  })
};
// 窜货商品详情分析
export const fleeingGoodsDetail = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/statistics/fleeingGoodsDetail',
    method: 'get',
    params
  })
};
// 仓库实时分析
export const warehousingPosition = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/statistics/warehousingPosition',
    method: 'get',
    params
  })
};
// 总部仓库转化分析
export const generalWarehousingPosition = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/statistics/generalWarehousingPosition',
    method: 'get',
    params
  })
};
// 经销商商品统计
export const dealerProduct = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/statistics/dealerProduct',
    method: 'get',
    params
  })
};
// 门店商品统计
export const storeProduct = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/statistics/storeProduct',
    method: 'get',
    params
  })
};

// 总部呆滞品分析
export const generalDeadProduct = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/statistics/generalDeadProduct',
    method: 'get',
    params
  })
};

// 渠道呆滞品分析
export const channelDeadProduct = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/statistics/channelDeadProduct',
    method: 'get',
    params
  })
};
// 渠道呆滞品详情分析
export const channelDeadProductDetail = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/statistics/channelDeadProductDetail',
    method: 'get',
    params
  })
};

// 经销商/门店商品统计>商品统计详情
export const getStatisticsProductDetail = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/statistics/productDetail',
    method: 'get',
    params
  })
};


// 垛标信息

export const get_virtual_info = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/code/get_virtual_info',
    method: 'get',
    params
  })
};


// 修改批次
export const changeWarehousingBatch = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/productBatch/changeWarehousingBatch',
    method: 'post',
    data
  })
};


// 虚拟垛标创建
export const virtual_code_to_associated = (data)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/virtual_code_to_associated',
    method: 'post',
    data
  })
};


// 调仓列表
export const transferWarehousing = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing',
    method: 'get',
    params
    })
  };
// 出库单列表导出
export const outWarehousingExport = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/outWarehousing/export',
    method: 'get',
    params
  })
};
// 调仓二维码明细
export const getTransFerWarehousingCode = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing/code/'+params.sn,
    method: 'get',
    params
  })
};

//退货单列表导出
export const refundExport = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/refund/export',
    method: 'get',
    params
  })
};



// 调仓详情
export const getTransferWarehousingSnMore = (id)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/transferWarehousing/'+id,
    method: 'get'
  })
};
//获取调仓单号
export const getTransferWarehousingSn = ()=>{
  return api_onlineOrder.request({
    url: '/fch/admin/transferWarehousing/code',
    method: 'get'
  })
};

// 快速调仓
export const setFastTransferWarehousing = (data)=>{
  return api_onlineOrder.request({
    url: '/fch/admin/transferWarehousing/scan',
    method: 'post',
    data
  })
};
// 创建调仓单
export const createTransferWarehousingOrder = (data)=>{
  return api_onlineOrder.request({
    url: '/fch/admin/transferWarehousing',
    method: 'post',
    data
  })
};
// 关闭调仓单
export const transferWarehousingClose = (transfer_warehousing_id)=>{
  return api_onlineOrder.request({
    url: '/fch/admin/transferWarehousing/close/'+transfer_warehousing_id,
    method: 'post'
  })
};
//导出列表-异步
export const adminExport = (params)=>{
  return api_onlineOrder.request({
    url: 'fch/admin/export',
    method: 'get',
    params
  })
}
